import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-default/index.css";
import VueRouter from "vue-router";
import store from "./vuex/store";
import Vuex from "vuex";
import routes from "./routes";
import "font-awesome/css/font-awesome.min.css";
import api from "./api/api";
var resCode = require("../server/common/data").resCode;
import Axios from 'axios'
// language
import VueI18n from 'vue-i18n'
import elementUiLocale from 'element-ui/lib/locale'
//引入剪切板插件clipboard;
import Clipboard from 'clipboard'; 
Vue.prototype.Clipboard=Clipboard;

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueI18n)

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (sessionStorage.getItem("login") === null) {
    api.identify({})
    .then(res => {
      if (res.data.CODE === resCode.SUCCESS) {
        sessionStorage.setItem("login", "true");
        sessionStorage.setItem("role", res.data.DATA.role);
        navigate(to, from, next, true);
      } else {
        sessionStorage.setItem("login", "false");
        sessionStorage.removeItem("role");
        navigate(to, from, next, false);
      }
    })
    .catch(err => {
      sessionStorage.removeItem("login"); // try next time
      sessionStorage.removeItem("role");
      navigate(to, from, next, false);
    });
  } else {
    navigate(to, from, next, (sessionStorage.getItem("login") === "true"));
  }
})

function navigate (to, from, next, authorized) {
  if (authorized) {
    if ((to.name === "login") || (to.name === "register")) {
      if (sessionStorage.getItem("role") === "admin") {
        next({name: "Users"});
      } else {
        next({name: "Project Management"});
      }
    } else {
      next();
    }
  } else {
    if (to.requireAuth) {
      next({name: "login"});
    } else {
      next();
    }
  }
}

Axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          sessionStorage.setItem("login", "false");
          sessionStorage.removeItem("role");
          router.replace({
            name: 'login',
            query: {redirect: router.currentRoute.fullPath}
          });
      }
    }
    return Promise.reject(error.response.data);
});

// 最后 export default，这一步肯定要写的。
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en_US',
  messages: {
    'zh_CN': require('./assets/i18n/zh-cn'),
    'en_US': require('./assets/i18n/en-us')
  }
});
elementUiLocale.i18n((key, value) => i18n.t(key, value))

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  i18n,
  store,
  //components: { App }
  render: h => h(App)
}).$mount("#app");

exports.router = router;



// WEBPACK FOOTER //
// ./src/main.js